/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   3/4/22
 */

import React from "react";
import {Autocomplete, TextField} from "@mui/material";
import countryNames from "../const/country-names";

export interface CountriesControlProps {
	label?: string;
	values: string[];
	onChange: (values: string[]) => void
	disabled?: boolean
}

const options = Object.entries(countryNames).map(([id, label]) => ({ id, label }));

export default function CountriesControl({ label, values, onChange, disabled }: CountriesControlProps) {

	return (
		<Autocomplete
			multiple
			options={options}
			value={options.filter(i => values.includes(i.id))}
			onChange={(_, v) => {
				if (v) {
					onChange(v.map(i => i.id));
				}
			}}
			ChipProps={{ size: "small" }}
			clearOnEscape
			fullWidth
			disabled={disabled}
			renderInput={(params) => (
				<TextField
					{...params}
					variant="standard"
					label={label}
				/>
			)}
		/>
	);

}